(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActionTypesEnum', actionTypesEnumFactory);

  /** @ngInject */
  function actionTypesEnumFactory () {
    return Object.freeze({
      //user
      SIGN_IN: 'SIGN_IN',
      //devices
      GET_DEVICES: 'GET_DEVICES',
      GET_DEVICE: 'GET_DEVICE',
      GET_KARCHER_DEVICE: 'GET_KARCHER_DEVICE',
      //messages
      GET_MESSAGES: 'GET_MESSAGES',
      GET_ALARM_MESSAGES: 'GET_ALARM_MESSAGES',
      GET_ALARM_KARCHER_MESSAGES: 'GET_KARCHER_ALARM_MESSAGES',
      GET_ALARM_FROM_DASHBOARD_MESSAGE: 'GET_ALARM_FROM_DASHBOARD_MESSAGE',
      //daily finances
      GET_DAILY_FINANCES: 'GET_DAILY_FINANCES',
      GET_DAILY_FINANCES_FOR_DEVICE: 'GET_DAILY_FINANCES_FOR_DEVICE',
      //reports
      UPDATE_REPORT_FILTER: 'UPDATE_REPORT_FILTER',
      CHANGE_FACILITY_POINT_ID : 'CHANGE_FACILITY_POINT_ID',
      //global
      SERVER_RESPONSE_PENDING: 'SERVER_RESPONSE_PENDING',
      SERVER_RESPONSE_FAILED: 'SERVER_RESPONSE_FAILED',
      SERVER_RESPONSE_SUCCESS: 'SERVER_RESPONSE_SUCCESS',
      //show/hide loader
      SHOW_LOADER : 'SHOW_LOADER',
      HIDE_LOADER : 'HIDE_LOADER',
      // show hide error msg
      SHOW_ERROR_MSG : 'SHOW_ERROR_MSG',
      HIDE_ERROR_MSG : 'HIDE_ERROR_MSG',
      // show toaster msg
      SHOW_TOASTER_MSG : 'SHOW_TOASTER_MSG',
      TOAST_TYPE_NOTIFICATION : 'TOAST_TYPE_NOTIFICATION',
      TOAST_TYPE_WARNING : 'TOAST_TYPE_WARNING',
      TOAST_TYPE_ERROR : 'TOAST_TYPE_ERROR',
      // error page
      SHOW_ERROR_PAGE : 'SHOW_ERROR_PAGE',
      HIDE_ERROR_PAGE : 'HIDE_ERROR_PAGE',
      //web sockets
      CONNECTED_CHANGE: 'CONNECTED_CHANGE',
      DEVICE_FEED_CHANGE: 'DEVICE_FEED_CHANGE',
      DEVICE_ACTUATOR_CHANGE: 'DEVICE_ACTUATOR_CHANGE',
      DEVICE_STATE_CHANGE: 'DEVICE_STATE_CHANGE',
      MESSAGES_UPDATE_AVAILABLE: 'MESSAGES_UPDATE_AVAILABLE',
      DAILY_FINANCES_CHANGE: 'DAILY_FINANCES_CHANGE',
      NOTICE_CHANGE: 'NOTICE_CHANGE',
      DEVICE_EVENT_CHANGE: 'DEVICE_EVENT_CHANGE'
    });
  }
})();
